import { render } from "./TournamentResultList.vue?vue&type=template&id=2d4eac48&scoped=true"
import script from "./TournamentResultList.vue?vue&type=script&lang=js"
export * from "./TournamentResultList.vue?vue&type=script&lang=js"

import "./TournamentResultList.vue?vue&type=style&index=0&id=2d4eac48&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d4eac48"]])

export default __exports__